import { Options, Vue } from "vue-class-component"
import { Inject } from "vue-property-decorator"
import { useFlag } from "@unleash/proxy-client-vue"

import { UnleashFlags } from "@/plugins/unleash"

@Options({
  name: "FeatureFlagCheck"
})
export class FeatureFlagCheck extends Vue {
  @Inject("featureFlag") readonly featureFlag!: UnleashFlags

  async created() {
    if (!this.featureFlag) return
    const enabled = useFlag(this.featureFlag)
    if (!enabled) {
      this.$router.replace("/404")
    }
  }
}
